import { z } from "zod";

export const subscriptionSchema = z.object({
  email: z.string().email("Please enter a valid email address.").min(5, "Email is too short."),
});

export type SubscriptionFormValues = z.infer<typeof subscriptionSchema>;
